export default "assets/images/icons/clock-9d105a4d.svg";